import { DragHandleOutlined } from "@mui/icons-material";
import { useContext } from "react";
import { SortableItemContext } from "./SortableItem";
import { IconButton } from "@mui/material";

export function DragHandle() {
    const { attributes, listeners, ref } = useContext(SortableItemContext);

    return (
        <IconButton
            className="DragHandle"
            {...attributes}
            {...listeners}
            ref={ref}
        >
            <DragHandleOutlined />
        </IconButton>
    );
}
